import { VariantSelectorModuleDictionary } from '../VariantSelectorModule.locale'

export const titleLookup: Record<number, VariantSelectorModuleDictionary> = {
  10: 'common.select_bouquet_size',
  9: 'common.select_size',
  11: 'common.select_size',
  12: 'common.what_size',
  13: 'common.select_size',
  15: 'common.select_size',
  19: 'common.select_size',
  17: 'common.select_size',
  21: 'common.select_bouquet_size',
  22: 'common.select_size',
  23: 'common.select_size',
  24: 'common.select_size',
  25: 'common.select_size',
  26: 'common.select_size',
  27: 'common.select_size',
  28: 'common.select_size',
  29: 'common.select_size',
  30: 'common.select_size',
  31: 'common.select_size',
  32: 'common.select_size',
  33: 'common.select_size',
  3: 'common.select_size',
  1: 'common.select_size',
}

export const getSelectorTitle = (
  categoryId: number,
  localiseText: (key: VariantSelectorModuleDictionary) => string,
) => {
  const titleLocalizationKey = titleLookup[categoryId]
  return titleLocalizationKey ? localiseText(titleLocalizationKey) : undefined
}
